import { forwardRef } from "react";
import { cn } from "../../lib/cn";

const VARIANTS = {
  primary:
    "bg-brand text-brand-contrast hover:bg-brand/90 focus-visible:ring-brand/50 disabled:bg-brand/40",
  secondary:
    "bg-surface-raised text-ink hover:bg-surface-raised/80 border border-edge focus-visible:ring-brand/40 disabled:opacity-50",
  ghost:
    "bg-transparent text-ink hover:bg-surface-raised/60 focus-visible:ring-brand/40 disabled:opacity-50",
  outline:
    "bg-transparent text-ink border border-edge-strong hover:bg-surface-raised/60 focus-visible:ring-brand/40 disabled:opacity-50",
  danger:
    "bg-danger text-white hover:bg-danger/90 focus-visible:ring-danger/50 disabled:bg-danger/40",
  link:
    "bg-transparent text-brand hover:underline underline-offset-2 px-0 py-0 focus-visible:ring-brand/40"
};

const SIZES = {
  sm: "h-8 px-3 text-sm gap-1.5 rounded-md",
  md: "h-10 px-4 text-sm gap-2 rounded-lg",
  lg: "h-12 px-5 text-base gap-2 rounded-lg",
  icon: "h-10 w-10 rounded-lg justify-center"
};

const Button = forwardRef(function Button(
  {
    variant = "primary",
    size = "md",
    type = "button",
    loading = false,
    disabled = false,
    iconStart,
    iconEnd,
    className,
    children,
    ...rest
  },
  ref
) {
  return (
    <button
      ref={ref}
      type={type}
      disabled={disabled || loading}
      className={cn(
        "inline-flex items-center font-medium select-none transition-colors",
        "outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-offset-surface",
        "active:scale-[0.98] motion-safe:transition-transform",
        VARIANTS[variant],
        SIZES[size],
        loading && "cursor-wait",
        className
      )}
      {...rest}
    >
      {loading ? (
        <span className="material-symbols-outlined animate-spin text-[18px]">progress_activity</span>
      ) : (
        iconStart && (
          <span className="material-symbols-outlined text-[18px] leading-none">{iconStart}</span>
        )
      )}
      {children && <span className="truncate">{children}</span>}
      {iconEnd && (
        <span className="material-symbols-outlined text-[18px] leading-none">{iconEnd}</span>
      )}
    </button>
  );
});

export default Button;
